import React from 'react'
import FooterLayout from './FooterLayout'

const StockItemSummaryFooter = (
    {
        isDisable,
        spaceFunction,
        removeLineFunction,
        restoreLineFunction,
    }
) => {
    const fields = [
        { id: "1", name: "Quit", shortcutKey: "Q", isDisabled: false, state:'' },
        { id: "2", name: "", shortcutKey: "", isDisabled: false, state:'' },
        { id: "3", name: "Select", shortcutKey: "Space", isDisabled: false, state:() => spaceFunction() },
        { id: "4", name: "", shortcutKey: "", isDisabled: false, state:'' },
        { id: "5", name: "", shortcutKey: "", isDisabled: false, state:'' },
        { id: "6", name: "", shortcutKey: "", isDisabled: false, state:'' },
        { id: "7", name: "", shortcutKey: "", isDisabled: false, },
        { id: "8", name: "", shortcutKey: "", isDisabled: false, },
        { id: "9", name: "Remove Line", shortcutKey: "R", line:'double', isDisabled: false, state: removeLineFunction },
        { id: "10", name: "Restore Line", shortcutKey: "U",line:'double', isDisabled: isDisable, state: restoreLineFunction },
    ]
    return (
        <div className='tomasterfooter'>
            <div className='footer'>
                {
                    fields.map((item, index) => {
                        return (
                            <FooterLayout key={item.id} fields={item} />
                        )
                    })
                }

            </div>
        </div>
    )
}

export default StockItemSummaryFooter
